import { render, staticRenderFns } from "./PorudzbeDostava.vue?vue&type=template&id=ffc4252a&scoped=true&"
import script from "./PorudzbeDostava.vue?vue&type=script&lang=js&"
export * from "./PorudzbeDostava.vue?vue&type=script&lang=js&"
import style0 from "./PorudzbeDostava.vue?vue&type=style&index=0&id=ffc4252a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc4252a",
  null
  
)

export default component.exports